import { Fade, makeStyles, TextField, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from './ClaimWizard';
import { separations } from '../../../constants/StyleConstants';
import { ClaimContext } from '../../../contexts/ClaimContext';
import ClaimsAPI from '../../../services/ClaimsAPI';
import { AppContext } from '../../../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const OtherClaim = () => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const [transIn, setTransIn] = useState(true);
  const [description, setDescription] = useState('');
  const { setStepElements, setOpenBackDrop, selectedClaimId } = useContext(ClaimContext);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      finishButtonText: 'Iniciar reclamo',
      finishButtonAction: () => sendClaim(description),
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
  }, [description]);

  const handleChangeDescription = value => {
    if (value.isBlank()) {
      setDescription('');
    } else {
      setDescription(value);
    }
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = description.isBlank())) errorMessages.push('Debe ingresar una descripción');

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const sendClaim = () => {
    return new Promise((resolve, reject) => {
      if (validate()) {
        setOpenBackDrop(true);

        const request = {
          idType: selectedClaimId,
          description: description,
        };

        ClaimsAPI.startClaim(request)
          .then(res => {
            resolve();
          })
          .catch(error => {
            setOpenBackDrop(false);
            showError('Error al iniciar reclamo');
          });
      } else {
        reject();
      }
    });
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout}>
      <div className={classes.root}>
        <Typography variant="subtitle2">Ingrese una descripción del reclamo que desea iniciar</Typography>
        <TextField
          className={classes.topSeparation}
          margin="dense"
          id="description"
          multiline
          rows={10}
          variant="outlined"
          label="Descripción"
          onChange={e => handleChangeDescription(e.target.value)}
          value={description}
        />
      </div>
    </Fade>
  );
};

export default OtherClaim;
